import Vue from 'vue'
import apis from '../../../api/index'

const queryAllDepartment = (keyWord) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_DEPARTMENT,
      params: {
        keyword: keyWord
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询顶级部门
const queryTopDepartment = () => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_TOP_DEPARTMENT
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询子部门
const queryChildDepartment = (parentId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_CHILD_DEPARTMENT,
      params: {
        parentId
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}

export default {
  editorConfigType: 'DEPTDEFAULTVALUE',
  componentName: 'FormConfigDeptDefault',
  configProperty: 'departmentDefaultValue',
  allowProperties: ['departmentDefaultValue', 'defaultValue'],
  extras: {
    queryAllDepartmentData: queryAllDepartment,
    queryTopDepartmentData: queryTopDepartment,
    queryChildDepartmentData: queryChildDepartment
  }
}
